/**
 * Le retour arrière d'Android et Échap sur le web appellent `onEscape` : ce qu'un calque se ferme
 * (`<Overlay>`) ou ce qu'une vue plein cadre rend (`<StudentLivePage>`). Rend de quoi détacher les
 * deux, à appeler au nettoyage de l'effet qui l'a posé.
 */
import { BackHandler, Platform } from "react-native"

type WebDocument = {
    addEventListener: (type: string, listener: (event: { key?: string }) => void) => void
    removeEventListener: (type: string, listener: (event: { key?: string }) => void) => void
}

export function listenEscape(onEscape: () => void): () => void {
    const sub = BackHandler.addEventListener("hardwareBackPress", () => {
        onEscape()
        return true
    })
    const doc = Platform.OS === "web" ? (globalThis as { document?: WebDocument }).document : undefined
    const onKeyDown = (event: { key?: string }) => {
        if (event.key === "Escape") onEscape()
    }
    doc?.addEventListener("keydown", onKeyDown)
    return () => {
        sub.remove()
        doc?.removeEventListener("keydown", onKeyDown)
    }
}
